export default "__VITE_ASSET__08b6ade6__"